const OFFSET_PERCENTAGE = 10 / 1.2;
export default function create(options) {
  const {
    direction = 'left'
  } = options.namedEffect;
  let fromValue = `${OFFSET_PERCENTAGE}%`;
  let toValue = `-${OFFSET_PERCENTAGE}%`;
  if (direction === 'right') {
    [fromValue, toValue] = [toValue, fromValue];
  }
  return [{
    ...options,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      transform: `translateX(${fromValue})`
    }, {
      transform: `translateX(${toValue})`
    }]
  }];
}
//# sourceMappingURL=BgPan.js.map